export default (arrayOfObj = []) => {
  return arrayOfObj.filter(obj => {
    if (obj) {
      return !obj.redacted
    }
    return false
  })
}
